import { useForm } from "react-hook-form";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { useToast } from "@/components/ui/use-toast";

export const PasswordReset = () => {
  const { toast } = useToast();
  const form = useForm();

  const handlePasswordReset = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user?.email) {
        throw new Error("No email found");
      }

      const { error } = await supabase.auth.resetPasswordForEmail(
        user.email,
        {
          redirectTo: `${window.location.origin}/auth`,
        }
      );
      
      if (error) throw error;
      
      toast({
        title: "Password Reset Email Sent",
        description: "Check your email for the password reset link.",
      });
    } catch (error: any) {
      toast({
        variant: "destructive",
        title: "Error",
        description: error.message || "Failed to send reset email",
      });
    }
  };

  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Password Reset</h2>
      <p className="text-gray-600 mb-4">
        Forgot your password? You can request a password reset email.
      </p>
      <Button
        variant="outline"
        onClick={handlePasswordReset}
      >
        Reset Password
      </Button>
    </div>
  );
};